import { render, staticRenderFns } from "./border-editor.vue?vue&type=template&id=5911b300&scoped=true&"
import script from "./border-editor.vue?vue&type=script&lang=js&"
export * from "./border-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911b300",
  null
  
)

export default component.exports